import {
  ButtonDirective,
} from 'app/components/call/BookingDetails/LessonBookingDetails/LessonOutcome/Button/ButtonDirective';
import ModalHelper from 'app/components/call/BookingDetails/LessonBookingDetails/LessonOutcome/Modal/ModalHelper';
import { useI18n } from 'app/components/localization';
import { ColorScheme } from 'app/components/presentation/buttons/ButtonClassNameA';
import { FontWeight } from 'app/components/presentation/text/styles';
import StressedOutOwl from 'app/components/svgs/mascot/StressedOutOwl';
import { useCss } from 'app/utils/css';
import React, { FC } from 'react';

interface ITimedOutModalProps {
  onClose: () => void;
}

/**
 * A modal presented to the user if the system locks a lesson automatically during a call.
 */
const TimedOutModal: FC<ITimedOutModalProps> = ({ onClose }) => {
  const { t, tx } = useI18n();
  const css = useCss();

  // Auxiliary text.
  const action = t('lesson-outcome.student.timed-out.modal.action');
  const content = tx('lesson-outcome.student.timed-out.modal.content', {
    action: <span className={css('action', { fontWeight: FontWeight.Bold })}>{action}</span>,
  });

  return (
    <ModalHelper
      alert={null}
      asset={StressedOutOwl}
      buttons={[{
        colorScheme: ColorScheme.Secondary,
        directive: ButtonDirective.Dashboard,
      }, {
        directive: ButtonDirective.BookLesson,
      }]}
      onClose={onClose}
      status={content}
      title={t('lesson-outcome.student.timed-out.modal.title')}
    />
  );
};

export default TimedOutModal;
